export const canUpdateHistoricalAmbient = (ambientData) => (
  ambientData?.status === 1 && Boolean(ambientData?.geojson)
)
